import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type HotelSettingsPreferredRateRoute from 'lumen/routes/hotel/settings/preferred-rate';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsPreferredRateController extends Controller {
  declare model: ModelFrom<HotelSettingsPreferredRateRoute>;
  // More naive change detection. Default is false, and is set to true when the user changes any setting.
  @tracked hasUserChangedPreferredRateSettingsValue = false;

  @action updateHasUserChangedPreferredRateSettingsValue(
    boolean: boolean,
  ): void {
    this.hasUserChangedPreferredRateSettingsValue = boolean;
  }
}
